import Layout from "layouts/Layout";
import Auth from "modules/Auth/Middleware/Auth";
import RafflesContent from "modules/Raffles";

import React from "react";
import { setTitle } from "utilities/helper/setTitle";

const RafflesPage: React.FC = () => {
  setTitle("Raffle List");
  return (
    <Auth>
      <Layout>
        <RafflesContent />
      </Layout>
    </Auth>
  );
};

export default RafflesPage;
